import type { IHeadingBlock } from '~/types/inputs';

export default function Heading({ label }: IHeadingBlock) {
	return <p className="col-span-6 font-subheading font-subheading leading-subheading">{label}</p>;
}
